import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FaIcon } from '../../../shared/components'

class MenuItemCloseButton extends Component {
  constructor(props){
    super(props)
  }

  render(){
    return (
      <button className="dashboard-menu-item md-visible close-button" onClick={ () => this.props.toggleMenu() }>
        <FaIcon icon='times-circle-o' /> Close
      </button>
    )
  }
}

MenuItemCloseButton.propTypes = {
  toggleMenu: PropTypes.func,
}

export default MenuItemCloseButton
